import {moment} from "../../services/moment-extensions";

export const defaultDateRange = [
    {
        label: 'Last 30 days',
        value: 30
    },
    {
        label: 'Last 90 days',
        value: 90
    },
    {
        label: 'Last 180 days',
        value: 180
    },
]

export const getDateRange = (range = 90) => {
    const to = moment().endOf('day').toApiDateTime();
    const from = moment().subtract(range, 'days').startOf('day').toApiDateTime();
    return {from, to};
};
